import { css, Global } from '@emotion/core';
import { gutters } from 'app/spacing';
import { APP_INSET_RIGHT_CLASS, APP_INSET_RIGHT_VAR } from './appInset';

const active = `html.${APP_INSET_RIGHT_CLASS}`;
const insetRight = `var(${APP_INSET_RIGHT_VAR})`;

export const SESSION_BLOCKER_CLASS = 'session-blocker';

const DIALOG_SIDE_GUTTERS = gutters.spacing(4);

export const appInsetDialogMaxWidth = (limit: string) =>
  `min(${limit}, calc(100% - ${DIALOG_SIDE_GUTTERS}px))`;

const dialogScope = `html:where(.${APP_INSET_RIGHT_CLASS}) :where(.modal:not(.${SESSION_BLOCKER_CLASS}))`;

const appInsetCss = css`
  ${active} #root {
    margin-right: ${insetRight};
  }

  ${active} .modal:not(.${SESSION_BLOCKER_CLASS}) {
    right: ${insetRight};
    width: auto;
  }

  ${active} .modal-backdrop:not(:has(+ .modal.${SESSION_BLOCKER_CLASS})) {
    right: ${insetRight};
    width: auto;
  }

  @media (min-width: 576px) {
    ${dialogScope} .modal-dialog {
      max-width: ${appInsetDialogMaxWidth('500px')};
    }
    ${dialogScope} .modal-sm {
      max-width: ${appInsetDialogMaxWidth('300px')};
    }
  }

  @media (min-width: 992px) {
    ${dialogScope} .modal-lg,
    ${dialogScope} .modal-xl {
      max-width: ${appInsetDialogMaxWidth('800px')};
    }
  }

  @media (min-width: 1200px) {
    ${dialogScope} .modal-xl {
      max-width: ${appInsetDialogMaxWidth('1140px')};
    }
  }

  ${active} #floating-window-root .floating-window-trigger-parent-right {
    right: ${insetRight};
  }
`;

export const AppInsetStyles = () => <Global styles={appInsetCss} />;
